export class EmailTemplateModel {
    public Id: number;

    public Label: string;

    public Title: string;

    public TypeId: number;

    public TypeName: string;

    public Content: string;

    public RejectionReasons: Array<RejectionReasonModel>;
}

export class RejectionReasonModel {
    public Id: number;

    public Content: string;
}
